const $ =  require('jquery');

/**
 * Add support for first tap to show the dropdown,
 * second tap to click the link in the main navbar.
 */
const hoverSimulator = function (e) {
    $(this).focus().unbind('click', hoverSimulator);
    e.preventDefault();
};
$('#main-navbar').on('touchstart', 'ul.navbar-nav > li > a', function () {
    $(this)
        .not(':focus')
        .filter(function () {
            return $(this).next().is('ul');
        })
        .on('click', hoverSimulator);
});

/**
 * Add menu items justify if needed
 */
$('#main-navbar ul.navbar-nav').each(function () {
    if ($(this).children('li').length >= 10) {
        $(this).addClass('navbar-justify');
    }
});